var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 19,
    width: 36.75,
    height: 4.16667,
    rx: 2,
    fill: "#1F375B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29.8334,
    width: 36.75,
    height: 4.16667,
    rx: 2,
    fill: "#1F375B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 40.6667,
    width: 36.75,
    height: 4.16667,
    rx: 2,
    fill: "#1F375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHamburger);
export default __webpack_public_path__ + "static/media/ico-hamburger.dfdb43ef2193cca6bdfebd1aa2d5a96f.svg";
export { ForwardRef as ReactComponent };